import { __DepositMethodsEnum } from './deposit.interface';

export const DepositMethods = [
    { title: 'کارت به کارت/پل/پایا/ساتنا (آنی)', key: __DepositMethodsEnum.cardToCard },
    { title: 'واریز درگاهی', key: __DepositMethodsEnum.direct },
    { title: 'واریز شناسه دار', key: __DepositMethodsEnum.cashInDeposit },
    { title: 'واریز آفلاین', key: __DepositMethodsEnum.offlineDeposit },
];
